import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_PARCEL_PRICE_CONFIGURATION,
  CLEAR_PARCEL_PRICE_CONFIGURATIONS,
  FLAG_GETTING_PARCEL_PRICE_CONFIGURATIONS,
  FLAG_PARCEL_PRICE_CONFIGURATION_ACTIVITY,
  GET_PARCEL_PRICE_CONFIGURATION,
  GET_PARCEL_PRICE_CONFIGURATIONS,
} from '../../../actions/types/cargo/ParcelPriceConfiguration';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_PARCEL_PRICE_CONFIGURATIONS:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_PARCEL_PRICE_CONFIGURATIONS:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_PARCEL_PRICE_CONFIGURATIONS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_PARCEL_PRICE_CONFIGURATION_ACTIVITY:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_PARCEL_PRICE_CONFIGURATION:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_PARCEL_PRICE_CONFIGURATION:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
